<template>
	<!-- banner -->
	<section v-if="topoBanner !=''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- clientes -->
	<section class="ftco-section bg-light">
		<div class="container">
			<div v-if="clientesTexto !=''" class="row justify-content-center mb-5 pb-5">
				<div class="col-md-7 heading-section text-center ">
					<span class="subheading">{{ clientesTexto[0].itiNome }}</span>
					<h2 class="mb-4">{{ clientesTexto[0].itiReferencia }}</h2>
				</div>
			</div>

			<!-- lista clientes -->
			<div v-if="clientesLista !=''" class="row d-flex">
				<div v-for="cliente in clientesLista" :key="cliente.itiId" class="col-md-3">
					<div class="marcas img shadow d-flex justify-content-center align-items-center">
						<img :src="$imgURL + cliente.insInstitucionalImagens[0].itgUrlImagem">
						<div class="overlay"></div>
					</div>
					<div style="text-align: center;"><p>{{ cliente.itiNome }}</p></div>
				</div>
			</div>
			<!-- END lista clientes -->
			
		</div>
	</section>
	<!-- END clientes -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'


export default {
	name: 'ClientesView',
	components: {
		
	},

	data: () => ({
		topoBanner: [],
		clientesTexto: [],
		clientesLista: [],
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Clientes - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/42/clientestopo/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo Banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca o texto
		axios.get('/Process/InsInstitucional/institucional/43/clientestexto/0/x')
			.then(response => {
				this.clientesTexto = response.data;
				//console.log('clientes texto')
				//console.log(this.clientesTexto)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca a lista de clientes
		axios.get('/Process/InsInstitucional/institucional/44/listaclientes/0/x')
			.then(response => {
				this.clientesLista = response.data.filter(x=> x.itiVisivel).sort((a, b) => {
                          const valorA = parseInt(a.itiOrdem) || 0;
                          const valorB = parseInt(b.itiOrdem) || 0;
                          return valorA - valorB;
                        });
				//console.log('clientes lista')
				//console.log(this.clientesLista)
			})
			.catch(error => {
				console.error(error);
			});
		
		

	},
}

</script>

<style scoped></style>
